import { TooltippedSpan } from '@mews-commander/ui';
import { Position } from '@optimus-web/core';

interface TooltipWrapperProps {
    active: boolean;
    tooltip: React.ReactNode;
}

export const TooltipWrapper: React.FC<React.PropsWithChildren<TooltipWrapperProps>> = ({
    active,
    children,
    tooltip,
}) => (
    <TooltippedSpan tooltip={active ? tooltip : null} tooltipDelay={300} tooltipPosition={Position.Bottom}>
        {children}
    </TooltippedSpan>
);
